export default __webpack_public_path__ + "static/media/walletconnect.304e3277.svg";